var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttons" }, [
    _c(
      "div",
      { staticClass: "btn marginBotton" },
      [
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPrimeiroPasso,
                expression: "!isPrimeiroPasso"
              }
            ],
            attrs: { type: "default", name: "voltar" },
            on: { click: _vm.voltarAba }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-chevron-left" }),
              _vm._v(" "),
              _c("span", [_vm._v("  Voltar")])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonCancelar && !_vm.isIntroPasso,
                expression: "showButtonCancelar && !isIntroPasso"
              }
            ],
            staticClass: "cancelarButton",
            attrs: { name: "cancelar" },
            on: { click: _vm.cancelar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-times" }),
              _vm._v(" "),
              _c("span", [_vm._v("  Cancelar")])
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonSalvar,
                expression: "showButtonSalvar"
              }
            ],
            staticClass: "buttonMargin",
            attrs: { type: "success", name: "salvar" },
            on: { click: _vm.salvar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-save" }),
              _vm._v(" "),
              _c("span", [_vm._v("  Salvar")])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonDownload,
                expression: "showButtonDownload"
              }
            ],
            attrs: { type: "default", name: "download" },
            on: { click: _vm.download }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("span", [_vm._v("Download PDF ")]),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-download" })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isUltimoPasso,
                expression: "!isUltimoPasso"
              }
            ],
            staticClass: "buttonMargin",
            attrs: { type: "default", name: "proximo" },
            on: { click: _vm.proximo }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("span", [_vm._v("Próximo ")]),
              _vm._v(" "),
              _c("i", { staticClass: "fas fa-chevron-right" })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isUltimoPasso,
                expression: "isUltimoPasso"
              }
            ],
            attrs: { type: "primary", name: "finalizar" },
            on: { click: _vm.finalizar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fa fa-check" }),
              _vm._v(" "),
              _c("span", [_vm._v(" " + _vm._s(_vm.finalizarLabel))])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40fedbd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40fedbd9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Buttons/ButtonsCadastroSicarf/ButtonsCadastroSicarf.vue
// module id = null
// module chunks = 